import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const DATABASE_ID = import.meta.env.VITE_FIREBASE_DATABASE_ID!;

// Initialize Firebase (singleton pattern for Next.js)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firestore
export const db = getFirestore(app, DATABASE_ID);

// Initialize Firebase Authentication
export const auth: Auth = getAuth(app);

// ── Bimantara secondary Firebase app (read-only Firestore for live bidding) ──
// Only apiKey + projectId needed for Firestore reads. No auth credentials exposed.
const bimantaraFirebaseConfig = {
  apiKey: import.meta.env.VITE_BIMANTARA_FIREBASE_API_KEY,
  projectId: import.meta.env.VITE_BIMANTARA_FIREBASE_PROJECT_ID,
};

const bimantaraApp =
  getApps().find(a => a.name === 'bimantara') ??
  initializeApp(bimantaraFirebaseConfig, 'bimantara');

export const bimantaraDb = getFirestore(bimantaraApp);

export default app;
